import { Text } from '@bancobarigui/barihaus';

import { FormLogo } from '@/components/FormLogo';
import { ResetPasswordForm } from './ResetPasswordForm';
import { PublicRouteContainer } from '@/components/PublicRouteContainer';

import { useResetPassword } from './useResetPassword';

export default function ResetPassword() {
  const { handleSubmit, loading } = useResetPassword();

  return (
    <PublicRouteContainer>
      <FormLogo />

      <Text>Informe sua nova senha:</Text>

      <ResetPasswordForm onFinish={handleSubmit} loading={loading} />
    </PublicRouteContainer>
  );
}
